import { Component, OnInit } from '@angular/core';
import { IffhsService } from 'src/app/data-services/iffhs.service';
import { MessageService } from 'src/app/data-services/message.service';
// import countries from '../../../../assets/json/countries.json';

@Component({
  selector: 'app-fans',
  templateUrl: './fans.component.html',
  styleUrls: ['./fans.component.css']
})
export class FansComponent implements OnInit {
  searchText: string;
  countries = [];
  fans: [];
  selectedId: number;
  activePro = true;
  isLoaderVisible = false;
  language = '';
  direction;
  defaultLanguage;
  // countryList: { name: string, id: string }[] = countries;

  constructor(
    private iffhsService: IffhsService,
    private messageService: MessageService) {
    this.messageService.selectedLanguage.subscribe(res => {
      this.language = res.lang;
      this.direction = res.dir;
    });
  }

  ngOnInit(): void {
    this.defaultLanguage = JSON.parse(localStorage.getItem('language'));
    this.direction = this.defaultLanguage.dir;
    this.getCountriesFans();
  }

  getCountriesFans() {
    this.isLoaderVisible = true;
    this.iffhsService.getCountriesFans().subscribe((res: any) => {
      this.countries = res.countries;
      this.fans = res.fans;
      this.isLoaderVisible = false;
    });
  }
  getContinent(id: number) {
    this.isLoaderVisible = true;
    this.activePro = false;
    const data = {
      continentId: id,
    };
    this.iffhsService.getGeneralContinent(data).subscribe((res: any) => {
      if (res[0].continent_id === 1) {
        this.countries = res;
        this.selectedId = 1;
        this.isLoaderVisible = false;

      } else if (res[0].continent_id === 3) {
        this.countries = res;
        this.selectedId = 3;
        this.isLoaderVisible = false;

      } else if (res[0].continent_id === 4) {
        this.countries = res;
        this.selectedId = 4;
        this.isLoaderVisible = false;
      } else if (res[0].continent_id === 5) {
        this.countries = res;
        this.selectedId = 5;
        this.isLoaderVisible = false;
      } else if (res[0].continent_id === 6) {
        this.countries = res;
        this.selectedId = 6;
        this.isLoaderVisible = false;
      } else if (res[0].continent_id === 7) {
        this.countries = res;
        this.selectedId = 7;
        this.isLoaderVisible = false;
      }
    });

  }
}
